import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false


//去除公共样式，引入rem
import "@/assets/css/common.css"
import "@/assets/css/reset.css"
import "@/assets/js/pxtorem.js"
// import "@/assets/js/px.js"
// import "@/assets/js/rem.js"

//引入axios
import axios from 'axios'
Vue.prototype.$axios = axios

//引入elementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入vue-amap
import AMap from 'vue-amap';
// 初始化vue-amap
Vue.use(AMap);
AMap.initAMapApiLoader({
	// 高德的key
	key: '****************',
	// 插件集合
	plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch','AMap.Geolocation',
		'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor',
		'AMap.CircleEditor', 'Geocoder',],
	// 高德 sdk 版本，默认为 1.4.4
	v: '2.0'
});

//引入百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: "WFKACU6v7aiUdnkgtMCqdWBZC68KpUXv"
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
